module.exports = __webpack_public_path__ + "static/media/55.d0de3d36.png";